<template>
  <v-row style="height: 100%" no-gutters>
    <v-dialog v-model="companyDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Company Code</v-card-title>
        <v-card-text>
          <p>Please enter your company code</p>
          <v-text-field
            label="Company Code"
            v-model="companyValue"
            autofocus
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="companyValue.length < 1" color="green darken-1" text @click.native="setCompanyValue()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col lg="6" offset-lg="3">
      <v-card height="100%" v-if="pinVisible">
        <p class="headline text-center py-1 mb-0">Please Enter Your PIN Code</p>
        <v-container fluid v-if="pinLength <= 4">
          <v-row no-gutters class="text-center px-5 py-0">
            <v-col cols="3">
              <v-icon medium :class="this.value.length > 0 ? 'green--text' : ''">{{ this.value.length > 0 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
            </v-col>
            <v-col cols="3">
              <v-icon medium :class="this.value.length > 1 ? 'green--text' : ''">{{ this.value.length > 1 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
            </v-col>
            <v-col cols="3">
              <v-icon medium :class="this.value.length > 2 ? 'green--text' : ''">{{ this.value.length > 2 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
            </v-col>
            <v-col cols="3">
              <v-icon medium :class="this.value.length > 3 ? 'green--text' : ''">{{ this.value.length > 3 ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid v-else>
          <v-text-field
            label="PIN Code"
            v-model="value"
            type="password"
            :maxlength="pinLength"
            class="mx-6"
          ></v-text-field>
        </v-container>
        <v-row class="text-center px-5 pb-5 ma-0">
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(1)">1</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(2)">2</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(3)">3</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(4)">4</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(5)">5</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(6)">6</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(7)">7</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(8)">8</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(9)">9</v-btn>
            </v-col>
            <v-col cols="4">
            </v-col>
            <v-col cols="4">
              <v-btn class="primary" fab text large @click="addDigit(0)">0</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="primary--text" fab text large @click="removeDigit()"><v-icon>backspace</v-icon></v-btn>
            </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-snackbar
      v-model="unauthorised"
      color="error"
      multi-line
      :timeout="-1">
      <v-icon large class="mr-4">error</v-icon>
      {{unauthorisedMsg}}
      <v-btn
        dark
        text
        @click="unauthorised = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import axios from 'axios'
export default {
  props: ['company', 'emp'],
  data: () => ({
    value: '',
    companyValue: '',
    companyDialog: false,
    pinVisible: false,
    unauthorised: false,
    unauthorisedMsg: '',
    companyCharcodes: '',
    pinCharcodes: '',
    pinLength: 4
  }),
  created () {
    if (this.emp !== undefined && this.setCompany !== null) {
      console.log(this.emp)
      console.log(this.company)
      let n = 0
      while (n < this.company.length) {
        this.companyCharcodes = this.companyCharcodes + '#' + this.company.charCodeAt(n)
        n++
      }
      n = 0
      while (n < this.emp.length) {
        this.pinCharcodes = this.pinCharcodes + '#' + this.emp.charCodeAt(n)
        n++
      }
      this.value = this.emp
      // this.submitPin()
    } else if (this.company) {
      this.$store.dispatch('checkCompany', this.company)
      this.pinVisible = true
      this.getPinLength()
    } else if (this.setCompany === null) {
      this.companyDialog = true
      this.pinVisible = true
    } else {
      this.getPinLength()
      this.pinVisible = true
    }
  },
  mounted () {
    this.$store.dispatch('checkLoginTime')
  },
  computed: {
    setCompany () {
      if (this.company !== undefined) {
        return this.company
      } else {
        return this.$store.getters.company
      }
    },
    url () {
      return this.$store.getters.url
    },
    autosignin () {
      if (this.company && this.emp) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    value: function (val) {
      if (val.length >= this.pinLength) {
        this.submitPin()
      }
    }
  },
  methods: {
    submitPin () {
      if (this.value.length >= this.pinLength) {
        this.unauthorised = false
        axios.post(this.url + `/dms-service/getEmpFromPin.ajax.php`, {
          company: this.companyCharcodes ? this.companyCharcodes : this.setCompany,
          pin: (this.emp ? this.pinCharcodes : this.value),
          autosignin: this.autosignin
        })
          .then(response => {
            localStorage.setItem('company', response.data.company)
            this.$store.dispatch('checkCompany', response.data.company)
            if (response.data.empID === -2) {
              this.unauthorised = true
              this.unauthorisedMsg = 'You are not authorised to use T&A. Please contact your system administrator for assistance.'
              this.value = ''
            } else if (response.data.empID !== undefined) {
              this.$store.dispatch('signUserIn', response.data)
              this.$router.push('/')
            } else {
              this.value = ''
              this.unauthorised = true
              this.unauthorisedMsg = 'There was a problem signing in. This may be because you used an invalid pin number.'
              this.pinVisible = true
            }
          }).catch((error) => {
            console.log(error)
            this.value = ''
            this.unauthorised = true
            this.unauthorisedMsg = 'There was a problem signing in. Please check your internet connection and try again.'
            this.pinVisible = true
          })
      }
    },
    addDigit (digit) {
      this.value += digit
    },
    removeDigit () {
      this.value = this.value.slice(0, -1)
    },
    setCompanyValue () {
      this.$store.dispatch('checkCompany', this.companyValue)
      this.companyDialog = false
      this.getPinLength()
    },
    getPinLength () {
      this.pinVisible = false
      axios.post(this.url + `/dms-service/getPinLength.ajax.php`, {
        company: this.companyCharcodes ? this.companyCharcodes : this.setCompany
      })
        .then(response => {
          if (response.data.pinLength) {
            this.pinLength = response.data.pinLength * 1
            this.pinVisible = true
          } else {
            this.pinVisible = true
          }
        }).catch(() => {
          this.pinVisible = true
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Signin.vue